import { getLocation } from './navigation.js'

export async function sendEvent(e, location) {
    try {
        await fetch('/api/algolia', {
            method: 'POST',
            body: JSON.stringify(e),
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        })
        return null
    } catch (e) {
        return null
    }
}

export async function handleEvent(e, cb, options) {
    let location = null
    if (options.require_location) {
        try {
            location = await getLocation()
        } catch (e) { }
    }

    try {
        await sendEvent(
            {
                ...e,
                browser_data: {
                    user_agent: navigator.userAgent,
                    language: navigator.language,
                    screen_resolution: `${window.screen.width}x${window.screen.height}`,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
                location: location
                    ? {
                        latitude: location.coords.latitude,
                        longitude: location.coords.longitude,
                    }
                    : null,
            },
            location
        )
    } catch (err) { }

    if (cb) cb()
    return null
}

window.addEventListener('DOMContentLoaded', () => {
    window.handleEvent = handleEvent;
})
